<template>
  <div
    :class="[
      showValidationErrors && required && selections?.length < 1
        ? 'mb-5'
        : 'mb-2',
      { relative: required },
    ]"
  >
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>

    <p class="mb-1 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <div
      class="mt-4 grid gap-2 md:grid-cols-2"
      :class="[orderedOptions?.length > 2 ? 'lg:grid-cols-3' : '']"
    >
      <div
        v-for="option in orderedOptions"
        :key="option"
        class="mb-2 w-full md:mb-2"
      >
        <radio-button
          :item="option.value"
          :active="selections.includes(option.id)"
          :handle-select="() => handleSelect(option.id)"
          :name="option.id"
          :require-checked="showValidationErrors && required"
        />
      </div>
    </div>
    <div
      v-if="showValidationErrors && required && selections?.length < 1"
      class="absolute -bottom-2 pl-1 text-3xs text-red-500"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue';
import _ from 'lodash';

export default {
  name: 'Checkbox',
  components: {
    RadioButton,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    currentAnswerObject: [Object, Boolean],
  },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      selections: [],
    };
  },
  computed: {
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
    },
    currentTaxForm() {
      return this.$store.state.taxQuestions.current_tax_form;
    },
    showValidationErrors() {
      if (this.currentTaxForm?.length < 1) return false;
      return this.$store.state.taxQuestions.show_validation_errors[
        this.currentTaxForm
      ];
    },
  },
  created() {
    let recentAnswer = this.question?.most_recent_previous_answer;
    if (recentAnswer)
      this.selections = recentAnswer.answer_options.map(
        (el) => el.tax_question_option_id
      );

    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      if (this.currentAnswerObject?.answer_options?.length > 0) {
        this.selections = this.currentAnswerObject?.answer_options.map(
          (el) => el.tax_question_option_id
        );
      }
      if (this.question?.options?.length > 0) {
        this.defaultSelection = this.question.options.filter(
          (el) => el.id == this.selection
        )[0];
      }
      if (this.selections?.length > 0) {
        this.presetSavedValue();
      }
    }
  },
  methods: {
    handleSelect(id) {
      if (!this.selections.includes(id)) {
        this.selections = [...this.selections, id];
      } else {
        this.selections = this.selections.filter((el) => el !== id);
      }
      let answerOptions = this.selections.map((el) => {
        return { tax_question_option_id: el };
      });

      if (this.required) {
        this.selections.length
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      let body = null;
      if (answerOptions?.length > 0) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          tax_answer_options_attributes: answerOptions,
        };
      }

      this.setTaxAnswers(body);

      this.emitForComparison(this.selections);
      // console.log('this.selections for checkbox');
      // console.dir(this.selections);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
      if (this.question?.group_parent_id !== null) {
        this.$emit(
          'group-check',
          this.question?.id,
          this.question?.group_parent_id,
          value
        );
      }
    },
    presetSavedValue() {
      let answerOptions = this.selections.map((el) => {
        return { tax_question_option_id: el };
      });

      if (this.required) {
        this.selections?.length > 0
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      let body = null;
      if (answerOptions?.length > 0) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          tax_answer_options_attributes: answerOptions,
        };
      }

      this.setTaxAnswers(body);

      this.emitForComparison(this.selections);
    },
  },
};
</script>
